import { Fragment } from 'react';
import '../css/styles.css';
import { Dialog, Transition } from '@headlessui/react'
import { db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';

const Modal = props => {
    const handleDelete = async() => {
        const docRef = doc(db, 'takenSeatsOUT', '5aadATVLnDArSFAEi2CA')
        const docRef2= doc(db, "departuresHistory", "8N1Nm7FoKCdHgiai3rEM");
        const response = await getDoc(docRef);
        const response2 = await getDoc(docRef2);
        const uuid = uuidv4(); 

        if(response.exists() && response2.exists()){
            const takenSeatsOUT = response.data().takenSeatsOUT;
            const departuresHistory = response2.data().departuresHistory;
            const deleteIndex = takenSeatsOUT.findIndex((seat) => seat.place === props.placeIdInfo);
            takenSeatsOUT.splice(deleteIndex, 1);

            const object = {
                status: 'Leaving the parking space',
                place: props.placeIdInfo,
                date: props.dateInfo,
                registrationNumber: props.registrationNumberInfo,
                containerNumber: props.containerNumberInfo,
                uid: uuid
            }
            
            departuresHistory.push(object);

            await setDoc(docRef, {
                takenSeatsOUT: takenSeatsOUT
            }).then(async() => {
                await setDoc(docRef2, {
                    departuresHistory: departuresHistory
                }).then(() => {
                    props.setChange(!props.change);
                    props.setOpen(false);
                })
            })
        }
    }

    return (
        <Transition.Root show={props.open}>
            <Dialog as="div" className="relative z-10" initialFocus={props.cancelButtonRef} onClose={() => {}}>
                <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
                >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center align-center p-4 text-center sm:items-center sm:p-0">
                    <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                    <Dialog.Panel style={{ display: 'flex', flexFlow: 'column nowrap', justifyContent: 'center', alignItems: 'center', height: '300px' }} className="relative width transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xs">
                        <div style={{ width: '100%', height: '70%' }} className="bg-white">
                        <div style={{ width: '100%' }} className="sm:flex sm:flex-col sm:items-center">
                            <div style={{ display: 'flex', flexFlow: 'column nowrap', justifyContent: 'center', alignItems: 'center', width: '100%' }} className="text-center mt-3">
                            <Dialog.Title as="h3" className="text-sm font-semibold leading-6 text-gray-900">
                                Container information
                            </Dialog.Title>
                            <div style={{ display: 'flex', flexFlow: 'column nowrap', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                                <p style={{ textAlign: 'center' }} className="text-sm text-gray-500 w-full">
                                    <strong>Parking place: </strong>{props.placeIdInfo}
                                </p>  
                                <p style={{ textAlign: 'center' }} className="text-sm text-gray-500 w-full">
                                    <strong>Date: </strong>{props.dateInfo}
                                </p>   
                                <p style={{ textAlign: 'center' }} className="text-sm text-gray-500 w-full">
                                    <strong>Registeration number: </strong>{props.registrationNumberInfo}
                                </p>  
                                <p style={{ textAlign: 'center' }} className="text-sm text-gray-500 w-full">
                                <strong>Container number: </strong>{props.containerNumberInfo}
                                </p>                              
                            </div>
                            </div>
                        </div>
                        </div>
                        <div className="bg-gray-50 px-4 py-3 w-full sm:flex sm:flex-row-reverse sm:px-6">
                        {props.OUT ? <button
                            type="button"
                            style={{ borderWidth: '2px', borderStyles: 'solid', borderColor: 'black', cursor: 'pointer', }}
                            className="amazon-button inline-flex w-full justify-center rounded-md px-3 py-2 text-sm"
                            onClick={() => handleDelete()}
                            id='modal-button'
                        >
                            Delete
                        </button> : ''}
                        <button
                            type="button"
                            style={{ cursor: 'pointer', }}
                            className="amazon-button-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm"
                            onClick={() => props.setOpen(false)}
                            id='modal-button'
                        >
                            Close
                        </button>
                        </div>
                    </Dialog.Panel>
                    </Transition.Child>
                </div>
                </div>
            </Dialog>
            </Transition.Root>
    )
}

export default Modal;